

















import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { OrderService, order, SetPriceData } from '@/api'

@Component({})
export default class SetPrice extends Vue {
  @Prop() currentOrder!: order

  expand = false

  setPrice (changed: order): void {
    if (changed.user_price === undefined) {
      return
    }

    const data: SetPriceData = {
      order_id: changed.id,
      price: changed.user_price
    }

    OrderService.setPrice({ requestBody: data }).then(resp => {
      if (resp.setted) {
        this.expand = false
      }
    })
  }

  collapse (): void {
    this.expand = !this.expand
  }
}
